import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ExecucaoRotinaDto, RotinaIntegracaoDto } from './integracao.dto';

/**
 * Disparo manual das rotinas de integração com o Theos — as mesmas que rodam por cron no backend.
 *
 * - `GET  /integracoes/rotinas`
 * - `POST /integracoes/rotinas/{codigo}/executar?aguardar=false`
 * - `POST /integracoes/rotinas/executar-todas`
 */
@Injectable({ providedIn: 'root' })
export class IntegracaoService {
  private readonly apiUrl = `${environment.api}/integracoes/rotinas`;

  constructor(private http: HttpClient) {}

  listarRotinas(): Observable<RotinaIntegracaoDto[]> {
    return this.http
      .get<RotinaIntegracaoDto[]>(this.apiUrl)
      .pipe(map((res) => (Array.isArray(res) ? res : [])));
  }

  /**
   * Dispara a rotina. Com `aguardar = false` (padrão) o backend responde **202** e executa em
   * segundo plano; se a rotina já estiver rodando, responde **409** com o mesmo DTO no corpo.
   */
  executar(codigo: string, aguardar = false): Observable<ExecucaoRotinaDto> {
    const params = new HttpParams().set('aguardar', String(aguardar));
    return this.http.post<ExecucaoRotinaDto>(
      `${this.apiUrl}/${encodeURIComponent(codigo)}/executar`,
      {},
      { params },
    );
  }

  /** Dispara todas as rotinas em sequência, em segundo plano (202). */
  executarTodas(): Observable<ExecucaoRotinaDto[]> {
    return this.http
      .post<ExecucaoRotinaDto[]>(`${this.apiUrl}/executar-todas`, {})
      .pipe(map((res) => (Array.isArray(res) ? res : [])));
  }
}
